import { useState, useEffect } from 'react';

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var isQueryActive = function isQueryActive(query, canCheckMediaQuery) {
  // Ensure that the window is available to prevent SSR issues
  if (canCheckMediaQuery) {
    return window.matchMedia(query).matches;
  }

  return false;
};

var useMediaQuery = function useMediaQuery(query) {
  var canCheckMediaQuery = typeof window !== 'undefined' && typeof window.matchMedia === 'function';

  var _useState = useState(isQueryActive(query, canCheckMediaQuery)),
      _useState2 = _slicedToArray(_useState, 2),
      queryIsActive = _useState2[0],
      setQueryState = _useState2[1];

  useEffect(function () {
    var checkQueryState = function checkQueryState() {
      var newQueryState = isQueryActive(query, canCheckMediaQuery);
      setQueryState(newQueryState);
    };

    checkQueryState();

    if (canCheckMediaQuery) {
      var mediaQueryList = window.matchMedia(query); // addListener is technically depricated, however to support older browser versions
      // we need to do a check for the method and utilize that when avialable

      if (mediaQueryList.addListener) {
        mediaQueryList.addListener(checkQueryState);
      } else {
        mediaQueryList.addEventListener('change', checkQueryState);
      }

      return function () {
        // removeListener is technically depricated, however to support older browser versions
        // we need to do a check for the method and utilize that when avialable
        if (mediaQueryList.removeListener) {
          mediaQueryList.removeListener(checkQueryState);
        } else {
          mediaQueryList.removeEventListener('change', checkQueryState);
        }
      };
    }

    return function () {
      return undefined;
    };
  }, [query, canCheckMediaQuery]);
  return queryIsActive;
};

export { useMediaQuery };
